import { combineReducers } from 'redux';

import { PasswordRecoveryAction } from '../types';
import {
  resendPasswordRecoveryRequest,
  resendPasswordRecoverySuccess,
  resendPasswordRecoveryFail,
} from '../actions';

const loading = (state = false, action: PasswordRecoveryAction) => {
  switch (action.type) {
    case resendPasswordRecoveryRequest.type:
      return true;

    case resendPasswordRecoverySuccess.type:
    case resendPasswordRecoveryFail.type:
      return false;

    default:
      return state;
  }
};

const error = (state: string | null = null, action: PasswordRecoveryAction) => {
  switch (action.type) {
    case resendPasswordRecoveryRequest.type:
    case resendPasswordRecoverySuccess.type:
      return null;

    case resendPasswordRecoveryFail.type:
      return action.payload.message;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  error,
});
